import { Chip } from '@mui/material'

export const RequiredChip = () => <Chip label="必須" color="error" size="small" variant="outlined" />
